/* Configuración global de GSAP (antes era un script inline tras animations.min.js). */
if (typeof gsap !== 'undefined') {
  if (typeof Power4 !== 'undefined') {
    gsap.defaults({ ease: Power4.easeOut });
  }
  gsap.config({ nullTargetWarn: false });
  if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }
}
